export class DialogManualCN {
    constructor(
      public data: any
    ) {}
  }